export const ROOM_NAME_MAX_LENGTH = 10;
export const ROOM_TRIP_MAX_LENGTH = 16;
export const ROOM_PROFILE_MAX_LENGTH = ROOM_NAME_MAX_LENGTH + 1 + ROOM_TRIP_MAX_LENGTH;

export function maskManualTripMarker(value: string): string {
  return value.replace(/◆/gu, "◇");
}

export function normalizePlayerProfile(value: string): string {
  const separator = value.indexOf("#");
  if (separator < 0) return maskManualTripMarker(value.trim().slice(0, ROOM_NAME_MAX_LENGTH));

  const name = maskManualTripMarker(value.slice(0, separator).trim().slice(0, ROOM_NAME_MAX_LENGTH));
  const trip = value.slice(separator + 1).trim().replace(/^#+/u, "").slice(0, ROOM_TRIP_MAX_LENGTH);
  return `${name}#${trip}`;
}
